<div class="ap-pp-planning-wizard-overview-stats">
  <h3>{{ title | translate }}</h3>
  <div class="ap-pp-planning-wizard-overview-stats-table">
    <div>
      <ap-dyngrids class="ap-statistic-grid"
                   [canCreate]="false"
                   [canSearch]="false"
                   [checkboxDisabled]="true"
                   [pageable]="false"
                   [scrollable]="'none'"
                   [columns]="statColumns"
                   [items]="statItems$ | async"
                   [groupable]="false"
                   [reorderable]="false"
                   [hideHeader]="true"
                   [selectable]="{enabled: false}">
      </ap-dyngrids>
    </div>
  </div>
</div>

